import type { ProductIngredients } from '../../../model';

/**
 * The label-order ingredient list (SSD-6639) as names fit to print.
 *
 * The endpoint hands back the catalogue's own strings, unprocessed, and two separators live in them
 * that are NOT the same thing:
 *
 *   - `;` separates synonyms of ONE ingredient — "Water;Aqua" is water, named twice. The label prints
 *     one name, so the first is kept and the rest dropped (API spec: split on `;` only).
 *   - `/` is part of a name — "Caprylic/Capric Triglyceride" is a single ingredient. Splitting on it
 *     would invent one, which is why nothing here touches it.
 *
 * Order is the label's own and is preserved. Duplicates are left alone: a label really can list an
 * ingredient twice, and collapsing that would misreport the formulation.
 */
export const convertProductIngredients = (ingredients: readonly string[]): ProductIngredients =>
  ingredients
    .map((entry) => entry.split(';')[0]?.trim() ?? '')
    // An entry that is blank, or only separators, names nothing — and must not print as an empty gap
    // between two commas.
    .filter((name) => name.length > 0);
